import { useMemo, useRef } from "react";
import Table from "views/merchandise/tables/BulkActionsTable";
import useCustomTableFilters from "hooks/useCustomTableFilters";
import { useAppSelector } from "redux/hooks";
import CreativeExpander from "./CreativeExpander";
import { buildTextColumn } from "views/merchandise/columns/buildTextColumn";

const DSPCreativesTable = ({ data = [], isLoading, expanderFilters = {} }) => {
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const tableRef = useRef();
  const TABLE_ID = "dspCreativesTable";
  const filterProps = useCustomTableFilters(TABLE_ID);

  const columnSpecs = useMemo(
    () => [
      buildTextColumn("creative_type", "Type", {
        width: 180,
        toolTip: `The creative's type`,
      }),
      buildTextColumn("creative_size", "Size", {
        toolTip: `The creative's size`,
        checked: false,
      }),
      { key: "dsp_sales", compareKey: "dsp_sales_percent" },
      { key: "dsp_total_sales", compareKey: "dsp_total_sales_percent" },
      { key: "dsp_ecpm", compareKey: "dsp_ecpm_percent" },
      { key: "dsp_impressions", compareKey: "dsp_impressions_percent" },
      { key: "dsp_clicks", compareKey: "dsp_clicks_percent" },
      { key: "dsp_cost", compareKey: "dsp_cost_percent" },
      { key: "dsp_total_purchases", compareKey: "dsp_total_purchases_percent" },
      { key: "dsp_units", compareKey: "dsp_units_percent" },
      { key: "dsp_total_units", compareKey: "dsp_total_units_percent", options: { checked: false } },
      { key: "dsp_ctr", compareKey: "dsp_ctr_delta" },
      {
        key: "dsp_total_acos",
        compareKey: "dsp_total_acos_delta",
        options: { checked: false },
      },
      {
        key: "dsp_total_roas",
        compareKey: "dsp_total_roas_delta",
        options: { checked: false },
      },
      {
        key: "dsp_total_detail_page_views",
        compareKey: "dsp_total_detail_page_views_percent",
        options: { checked: false },
      },
      {
        key: "dsp_total_detail_page_view_rate",
        compareKey: "dsp_total_detail_page_view_rate_delta",
        options: { checked: false },
      },
      {
        key: "dsp_total_add_to_cart",
        compareKey: "dsp_total_add_to_cart_percent",
        options: { checked: false },
      },
      {
        key: "dsp_new_to_brand_detail_page_views",
        compareKey: "dsp_new_to_brand_detail_page_views_percent",
        options: { checked: false },
      },
      {
        key: "dsp_new_to_brand_detail_page_views_rate",
        compareKey: "dsp_new_to_brand_detail_page_views_rate_delta",
        options: { checked: false },
      },
      {
        key: "dsp_total_new_to_brand_dpvs",
        compareKey: "dsp_total_new_to_brand_dpvs_percent",
        options: { checked: false },
      },
      {
        key: "dsp_total_new_to_brand_dpv_rate",
        compareKey: "dsp_total_new_to_brand_dpv_rate_delta",
        options: { checked: false },
      },
      {
        key: "dsp_brand_searches",
        compareKey: "dsp_brand_searches_percent",
        options: { checked: false },
      },
      {
        key: "dsp_brand_searches_rate",
        compareKey: "dsp_brand_searches_rate_delta",
        options: { checked: false },
      },
    ],
    [],
  );
  return (
    <Table
      marketPlace={marketPlace}
      tableRef={tableRef}
      tableId={TABLE_ID}
      isExpandable={true}
      isSelectable={false}
      titleCol={{
        id: "creative_name",
        isStatic: true,
        Header: "Line Item",
        accessor: "text",
        format: "text",
        style: { width: "300px" },
        width: 300,
        Cell: ({ row }) => {
          const { creative_name: dspCreativeName } = row?._original ?? {};

          return (
            <span
              style={{
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              {dspCreativeName}
            </span>
          );
        },
        Filter: () => null,
      }}
      data={data}
      columnSpecs={columnSpecs}
      getSearchCriteria={(row) => {
        const { creative_name: dspCreativeName } = row ?? {};
        return `${dspCreativeName}`;
      }}
      tableRowDescription={"Creatives"}
      defaultSorted={[{ id: "dsp_sales", desc: true }]}
      isLoading={isLoading}
      filterWidget={true}
      hideFilterToggleIcon={true}
      hideResetFiltersIcon={false}
      {...filterProps}
      handleBulkChanges={() => {}}
      minRows={1}
      selectionKey={"id"}
      ExpandedContent={({ row }) => <CreativeExpander row={row.row} expanderFilters={expanderFilters} />}
    />
  );
};

export default DSPCreativesTable;
